import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import SendArrow from '@/components/Icons/SendArrow';
import styles from './QuestionForm.module.css';
import type { FC, FormHTMLAttributes, SubmitEvent } from 'react';
import { useState } from 'react';
import classNames from '@/utils/classNames';
interface IQuestionFormProps extends Omit<FormHTMLAttributes<HTMLFormElement>, 'onSubmit'> {
  placeholder: string;
  /** Accessible name for the textarea. Defaults to the placeholder. */
  label?: string;
  /** Called with the trimmed question. Not called when the question is empty or submitting is disabled. */
  onSubmit: (question: string) => void;
  /** Disables the whole form, including the textarea. */
  isLoading?: boolean;
  /** Disables only the submit button, so the reader can keep typing. */
  canSubmit?: boolean;
  /** Tooltip on the submit button, explaining why it is disabled. */
  disabledReason?: string;
  clearOnSubmit?: boolean;
  autoFocus?: boolean;
}
export const QuestionForm: FC<IQuestionFormProps> = t0 => {
  const $ = _c(42);
  let disabledReason;
  let onSubmit;
  let placeholder;
  let rest;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      placeholder,
      label: t1,
      isLoading: t2,
      canSubmit: t3,
      disabledReason,
      clearOnSubmit: t4,
      autoFocus: t5,
      onSubmit,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = disabledReason;
    $[2] = onSubmit;
    $[3] = placeholder;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    disabledReason = $[1];
    onSubmit = $[2];
    placeholder = $[3];
    rest = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  const label = t1 === undefined ? placeholder : t1;
  const isLoading = t2 === undefined ? false : t2;
  const canSubmit = t3 === undefined ? true : t3;
  const clearOnSubmit = t4 === undefined ? false : t4;
  const autoFocus = t5 === undefined ? false : t5;
  const [question, setQuestion] = useState("");
  let t6;
  if ($[10] !== canSubmit || $[11] !== question) {
    t6 = !canSubmit || question.trim().length === 0;
    $[10] = canSubmit;
    $[11] = question;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const isSubmitDisabled = t6;
  let t7;
  if ($[13] !== canSubmit || $[14] !== clearOnSubmit || $[15] !== isLoading || $[16] !== onSubmit || $[17] !== question) {
    t7 = e => {
      e.preventDefault();
      const trimmed = question.trim();
      if (!trimmed || !canSubmit || isLoading) {
        return;
      }
      onSubmit(trimmed);
      if (clearOnSubmit) {
        setQuestion("");
      }
    };
    $[13] = canSubmit;
    $[14] = clearOnSubmit;
    $[15] = isLoading;
    $[16] = onSubmit;
    $[17] = question;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleSubmit = t7;
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classNames("cds-input-group", styles.fieldset);
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_0 => setQuestion(e_0.target.value);
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isSubmitDisabled) {
    t10 = e_1 => {
      if (e_1.key === "Enter" && !e_1.shiftKey && !e_1.nativeEvent.isComposing) {
        e_1.preventDefault();
        if (!isSubmitDisabled) {
          e_1.currentTarget.form?.requestSubmit();
        }
      }
    };
    $[21] = isSubmitDisabled;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== autoFocus || $[24] !== label || $[25] !== placeholder || $[26] !== question || $[27] !== t10) {
    t11 = <textarea name="question" rows={1} className={styles.question} value={question} onChange={t9} onKeyDown={t10} placeholder={placeholder} aria-label={label} autoFocus={autoFocus} />;
    $[23] = autoFocus;
    $[24] = label;
    $[25] = placeholder;
    $[26] = question;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SendArrow />;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== disabledReason || $[31] !== isLoading || $[32] !== isSubmitDisabled) {
    t13 = <Button data-cds-sizing="compact" className={styles.submitButton} type="submit" kind="primary" icon={t12} aria-label="Ask" isLoading={isLoading} disabled={isSubmitDisabled} title={disabledReason} />;
    $[30] = disabledReason;
    $[31] = isLoading;
    $[32] = isSubmitDisabled;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== isLoading || $[35] !== t11 || $[36] !== t13) {
    t14 = <fieldset disabled={isLoading} className={t8}>{t11}{t13}</fieldset>;
    $[34] = isLoading;
    $[35] = t11;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== handleSubmit || $[39] !== rest || $[40] !== t14) {
    t15 = <form {...rest} onSubmit={handleSubmit}>{t14}</form>;
    $[38] = handleSubmit;
    $[39] = rest;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
};